module.exports = __webpack_public_path__ + "img/r-130.60928804.jpg";